import Vue from 'vue'
import Vuex from 'vuex'
import SessionService from '@/services/SessionService'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		loggedInGuid: '',
		loggedInFullName: '',
		loginAttempted: false,
		loginFailed: false,
		statusMessage: '',
		shouldHideFlamingo: false
	},
	getters: {
		isLoggedIn: state => !!state.loggedInGuid,
		loginAttempted: state => state.loginAttempted,
		loginFailed: state => state.loginFailed,
		loggedInGuid: state => state.loggedInGuid,
		loggedInFullName: state => state.loggedInFullName,
		loginUrl: state => `${window.location.protocol}//${window.location.hostname}${window.location.port ? ':' + window.location.port : ''}/auth/discord`,
		statusMessage: state => state.statusMessage,
		shouldHideFlamingo: state => state.shouldHideFlamingo
	},
	mutations: {
		editLoggedInGuid(state, guid) {
			state.loggedInGuid = guid
		},
		editLoggedInFullName(state, fullName) {
			state.loggedInFullName = fullName
		},
		editLoginAttempted(state, boolValue) {
			state.loginAttempted = boolValue
		},
		editLoginFailed(state, isFailure) {
			state.loginFailed = isFailure
		},
		setStatusMessage(state, msg) {
			state.statusMessage = msg
		},
		setShouldHideFlamingo(state, boolValue) {
			state.shouldHideFlamingo = boolValue
		}
	},
	actions: {
		async checkLoggedInStateIfNeeded({ commit }) {
			if (!this.getters.loginAttempted) {
				this.dispatch('checkLoggedInState')
			}
		},
		async checkLoggedInState({ commit }) {
			const session = await SessionService.getSession()
			commit('editLoggedInGuid', session.data.guid)
			commit('editLoggedInFullName', session.data.fullName)
			commit('editLoginAttempted', true)

			if (!session.data.guid) {
				commit('editLoginFailed', true)
			}
		},
		async logout({ commit }) {
			const session = await SessionService.logout()
			commit('editLoggedInGuid', '')
			commit('editLoggedInFullName', '')
			commit('setStatusMessage', 'Logged out.')
		}
	}
})
